import Vue from 'vue'

import withRender from './search-field.html'
import './search-field.scss'

export default withRender(Vue.extend({
  data() { return { value: '' } },
  props: {
    describedBy: { type: String },
    fieldId: { type: String }, // when using input where label has "for" attribute
    labelId: { type: String }, // when using div where label has an id
    multiline: {
      type: Boolean,
      default: true
    },
    materialStyle: Boolean
  },
  computed: {
    inputClass() {
      return `tt-o-search-field__${this.materialStyle ? 'mat-' : ''}input`
    }
  },
  methods: {
    clearText() {
      if (this.multiline) {
        this.$refs.field.innerText = ''
      }
      this.value = ''
      this.$refs.field.focus()
    },
    onEnter() {
      this.$emit('onEnter')
    },
    update(e) {
      this.value = e.target.innerText
    }
  },
  watch: {
    value() {
      this.$emit('input', this.value)
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/form/search-field.ts